<template>
  <div class="group-list" v-if="container">
    <smooth-scrollbar>
      <div style="height:65vh">
        <div v-for="(group, i) in sort(container.groups)" :key="i">
          <project-group v-if="group.projects.length" :group="group" :index="i"></project-group>
        </div>
      </div>
    </smooth-scrollbar>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import ProjectGroup from "./project-group.component";
import _ from "lodash";
export default {
  components: {
    ProjectGroup
  },
  computed: {
    ...mapState(["container"])
  },
  methods: {
    sort(data) {
      if (!data) return [];
      return [
        ..._.orderBy(
          _.filter(data, (p) => p.properties && p.properties.date),
          [(p) => p.properties.date],
          ["desc"]
        ),
        ..._.orderBy(
          _.filter(data, (p) => !(p.properties && p.properties.date)),
          [(p) => p.name.toLowerCase()],
          ["asc"]
        ),
      ]

    }
  }
};
</script>